module.exports = __webpack_public_path__ + "static/media/imagem20.ee060a9b.jpeg";